(ns frontend.view.settings2.e-signature.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::visible-token-rows
 (fn [db]
   (get db ::visible-token-rows)))

(rf/reg-sub
 ::credentials
 (fn [db]
   (get db ::credentials)))

(rf/reg-sub
 ::selected-provider
 (fn [db]
   (get db ::selected-provider)))

(rf/reg-sub
 ::target-entity-type
 (fn [db [_]]
   (::target-entity-type db)))

(rf/reg-sub
 ::target-entity-id
 (fn [db [_]]
   (::target-entity-id db)))

(rf/reg-sub
 ::target-input-visible?
 (fn [db [_]]
   (::target-input-visible? db)))

(rf/reg-sub
 ::show-selection?
 (fn [db [_ i]]
   (get-in db [::credentials-ui i :show-selection?])))

(rf/reg-sub
 ::targets
 (fn [db [_ i]]
   (get-in db [::credentials i :targets])))

(rf/reg-sub
 ::edited-credential
 (fn [db [_ i]]
   (get-in db [::edited-credential])))
